import Vue from 'vue'
import {baseUrl} from "@/constants/app"
import authService from "@/services/auth/authService"

// axios
import axios from 'axios'

const axiosIns = axios.create({
  baseURL: baseUrl+'api/',
})

axiosIns.interceptors.request.use(config => {
  const platform = authService.activePlatform()

  // Si NO es una solicitud de login y platform está definido, agrega el header
  if (!config.url.includes('/login') && platform) {
    config.headers['X-PLATFORM'] = platform
  } else {
    delete config.headers['X-PLATFORM']
  }

  return config
}, error => Promise.reject(error))

Vue.prototype.$http = axiosIns

export default axiosIns
